<template>
  <v-dialog
    :value="printOpenOrdersModal"
    persistent
    fullscreen
    @keydown.enter="print"
  >
    <v-card>
      <v-row>
        <v-col cols="6">
          <div>
            <input
              class="hidden"
              id="input"
              @focus="closePrintOpenOrdersModal"
              type="text"
            />
          </div>
          <div class="settings">
            <label>Alles:</label
            ><input
              @change="viewOpenOrders"
              type="checkbox"
              v-model="allDates"
            />
            <label>Vanaf:</label
            ><input
              @change="viewOpenOrders"
              type="date"
              v-model="fromDate"
              :disabled="allDates"
            />
            <label>t/m:</label
            ><input
              @change="viewOpenOrders"
              type="date"
              v-model="toDate"
              :disabled="allDates"
            />
            <template v-if="isElectron">
              <label>Printer:</label
              ><select v-model="options.printer"
                ><option
                  v-for="printer of printers"
                  :key="printer.name"
                  :value="printer.name"
                >
                  {{ printer.displayName }}
                </option>
              </select>
              <label>Aantal:</label
              ><input type="number" v-model="options.copies" />
              <label>Formaat:</label
              ><select v-model="options.pageSize"
                ><option
                  v-for="pageSize of pageSizes"
                  :key="pageSize.value"
                  :value="pageSize.value"
                >
                  {{ pageSize.text }}
                </option>
              </select>
            </template>
          </div>
        </v-col>
        <v-col cols="6">
          <iframe
            :src="dataUrl"
            frameborder="0"
            id="iframe"
          ></iframe>
        </v-col>

        <v-footer fixed class="d-flex justify-center">
          <v-btn-toggle>
            <v-btn @click="closePrintOpenOrdersModal" color="primary"
              >Sluit</v-btn
            >
            <v-btn color="primary" @click="print">Afdrukken</v-btn>
          </v-btn-toggle>
        </v-footer>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { viewOpenOrders,printOpenOrders } from "../js/pdfController"
export default {
  name: "printOpenOrdersModal",
  props: {
    printOpenOrdersModal: Boolean,
    client: {},
    data: Array
  },
  data() {
    return {
      openOrders: this.data,
      dataUrl: "",
      buffer: "",
      fromDate: new Date(Date.now()).toISOString().split("T")[0],
      toDate: new Date(Date.now()).toISOString().split("T")[0],
      allDates: true,
      iframeLoaded: false,
      pageSizes: [
        {value: "A4", text: "A4"},
        {value: "A5", text: "A5"},
      ],
      options: {
        pageSize: "A4",
        copies: 1,
        printer: ""
      }
    }
  },
  methods: {
    iframeOnload() {
      let iframe = document.getElementById("iframe")
      iframe.removeEventListener("load", this.iframeOnload)
      if (
        iframe.contentDocument.readyState === "complete" &&
        this.iframeLoaded
      ) {
        this.printOpenOrders()
      } else {
        var that = this
        setTimeout(function() {
          return that.iframeOnload(iframe)
        }, 1000)
      }
    },
    async print() {
      if (this.isElectron) {
        this.printOpenOrders()
      } else {
      document
        .getElementById("iframe")
        .addEventListener("load", this.iframeOnload)
      await this.viewOpenOrders()
      this.iframeLoaded = true
      }
    },
    async printOpenOrders() {
      localStorage.setItem("printOpenOrdersOptions", JSON.stringify(this.options))
      if (this.isElectron) {
        let openOrders = this.allDates
        ? this.openOrders
        : this.openOrders.filter(
            order =>
              new Date(order.date) >= new Date(this.fromDate) &&
              new Date(order.date) <= new Date(this.toDate)
          )
        let options = {
          printer: this.options.printer,
          paperSize: this.options.pageSize,  
          copies: this.options.copies,
          scale: "fit",
          silent: true
        }
        this.buffer = await printOpenOrders(this.client, openOrders)
        window.ipcRenderer.send("printPdfBuffer", {
          buffer: this.buffer,
          options: options
        })
      } else
      document.getElementById("iframe").contentWindow.print()
      setTimeout(() => {
        let input = document.getElementById("input")
        input.focus()
      }, 1000)
    },
    closePrintOpenOrdersModal() {
      URL.revokeObjectURL(this.dataUrl)
      this.$emit("close-print-open-orders-modal")
    },
    async viewOpenOrders() {
      let openOrders = this.allDates
        ? this.openOrders
        : this.openOrders.filter(
            order =>
              new Date(order.date) >= new Date(this.fromDate) &&
              new Date(order.date) <= new Date(this.toDate)
          )
      let data = await viewOpenOrders(this.client, openOrders)
      this.dataUrl = URL.createObjectURL(data)
    }
  },
    computed: {
    isElectron() {
      return this.$store.state.isElectron 
    },
    printers(){
      return this.$store.state.printers
    }
  },
  async mounted() {
     if (JSON.parse(localStorage.getItem("printOpenOrdersOptions")) !== null) {
      let obj = JSON.parse(localStorage.getItem("printOpenOrdersOptions"))
      this.options = obj
    }
    await this.viewOpenOrders()
  }
}
</script>

<style scoped>
div.settings {
  justify-content: space-evenly;
  font-size: 2em;
  display: grid;
  grid-template-columns: max-content max-content;
  grid-gap: 5px;
}
input[type="checkbox"] {
  height: 1em;
  width: 1em;
}
div.settings label {
  text-align: right;
}
#iframe {
  height: 700px;
  width: 600px;
  margin: auto;
  padding: 0;
  display: block;
}
.hidden {
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>